import { Outlet, createFileRoute, useMatchRoute } from '@tanstack/react-router'
import { AppShell } from '../app/AppShell'
import { RequireAuth } from '../auth/RequireAuth'

function WorkspaceLayout() {
  const { workspaceId } = Route.useParams()
  const matchRoute = useMatchRoute()
  const conversation = matchRoute({ to: '/w/$workspaceId/conversations/$conversationId' })
  const initiative = matchRoute({ to: '/w/$workspaceId/initiatives/$initiativeId' })
  const submission = matchRoute({ to: '/w/$workspaceId/reviews/$submissionId' })
  return (
    <RequireAuth>
      <AppShell
        workspaceId={workspaceId}
        contentLayout={conversation || initiative || submission ? 'panes' : 'page'}
      >
        <Outlet />
      </AppShell>
    </RequireAuth>
  )
}

export const Route = createFileRoute('/w/$workspaceId')({ component: WorkspaceLayout })
